export const COHORT_LIST_REQUEST = 'COHORT_LIST_REQUEST';
export const COHORT_LIST_SUCCESS = 'COHORT_LIST_SUCCESS';
export const COHORT_LIST_FAIL = 'COHORT_LIST_FAIL';

export const COHORT_DETAILS_REQUEST = 'COHORT_DETAILS_REQUEST';
export const COHORT_DETAILS_SUCCESS = 'COHORT_DETAILS_SUCCESS';
export const COHORT_DETAILS_FAIL = 'COHORT_DETAILS_FAIL';
export const COHORT_DETAILS_RESET = 'COHORT_DETAILS_RESET';

export const COHORT_CREATE_REQUEST = 'COHORT_CREATE_REQUEST';
export const COHORT_CREATE_SUCCESS = 'COHORT_CREATE_SUCCESS';
export const COHORT_CREATE_FAIL = 'COHORT_CREATE_FAIL';
export const COHORT_CREATE_RESET = 'COHORT_CREATE_RESET';

export const COHORT_UPDATE_REQUEST = 'COHORT_UPDATE_REQUEST';
export const COHORT_UPDATE_SUCCESS = 'COHORT_UPDATE_SUCCESS';
export const COHORT_UPDATE_FAIL = 'COHORT_UPDATE_FAIL';
export const COHORT_UPDATE_RESET = 'COHORT_UPDATE_RESET';

export const COHORT_DELETE_REQUEST = 'COHORT_DELETE_REQUEST';
export const COHORT_DELETE_SUCCESS = 'COHORT_DELETE_SUCCESS';
export const COHORT_DELETE_FAIL = 'COHORT_DELETE_FAIL';

export const COHORT_DTO_REQUEST = 'COHORT_DTO_REQUEST';
export const COHORT_DTO_SUCCESS = 'COHORT_DTO_SUCCESS';
export const COHORT_DTO_FAIL = 'COHORT_DTO_FAIL';
export const COHORT_DTO_RESET = 'COHORT_DTO_RESET';

export const COHORT_LIST_BY_IDS_REQUEST = 'COHORT_LIST_BY_IDS_REQUEST';
export const COHORT_LIST_BY_IDS_SUCCESS = 'COHORT_LIST_BY_IDS_SUCCESS';
export const COHORT_LIST_BY_IDS_FAIL = 'COHORT_LIST_BY_IDS_FAIL';
export const COHORT_LIST_BY_IDS_RESET = 'COHORT_LIST_BY_IDS_RESET';

export const COHORT_SEND_COHORT_REQUEST = 'COHORT_SEND_COHORT_REQUEST';
export const COHORT_SEND_COHORT_SUCCESS = 'COHORT_SEND_COHORT_SUCCESS';
export const COHORT_SEND_COHORT_FAIL = 'COHORT_SEND_COHORT_FAIL';
export const COHORT_SEND_COHORT_RESET = 'COHORT_SEND_COHORT_RESET'; 